import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Spinner from 'components/Spinner'
import BarInfoComponent from './BarInfoComponent'
import SideBarConsosComponent from 'components/SideBarConsosComponent'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import _ from 'lodash'
const styles = theme => ({
  container: {
    position: 'relative',
    overflow: 'hidden'
  }
})

class BarComponent extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    transaction: PropTypes.object,
    showModal: PropTypes.func.isRequired,
    products: PropTypes.array.isRequired,
    categories: PropTypes.array.isRequired,
    selectCurrentTransaction: PropTypes.func.isRequired,
    addConso: PropTypes.func.isRequired,
    removeConso: PropTypes.func.isRequired,
    prepareForPayment: PropTypes.func.isRequired,
    changeReducConso: PropTypes.func.isRequired
  }
  componentWillReceiveProps(nextProps) {
    const { transaction } = nextProps
    if (!transaction) {
      this.props.selectCurrentTransaction(nextProps.match.params.barId, 'BAR')
      return
    }
    if (
      !transaction.bar ||
      transaction.bar.key !== nextProps.match.params.barId
    ) {
      this.props.selectCurrentTransaction(nextProps.match.params.barId, 'BAR')
      return true
    }
    return false
  }
  componentWillMount() {
    const { transaction } = this.props
    if (!transaction) {
      this.props.selectCurrentTransaction(this.props.match.params.barId, 'BAR')
      return
    }
    if (
      !transaction.bar ||
      transaction.bar.key !== this.props.match.params.barId
    ) {
      this.props.selectCurrentTransaction(this.props.match.params.barId, 'BAR')
    }
  }
  renderSpinner() {
    return <Spinner />
  }
  render() {
    const { classes, transaction } = this.props
    if (!transaction) return this.renderSpinner()
    const { products } = transaction
    let productsArray = []
    if (products) {
      productsArray = _.orderBy(
        Object.keys(products).map(key => ({ ...products[key], key: key })),
        ['createdAt'],
        ['asc']
      )
    }
    return (
      <Grid
        className={classes.container}
        item
        container
        direction="row"
        alignItems="stretch"
        justify="flex-start"
        spacing={16}>
        <Grid item xs={12} md={8}>
          <BarInfoComponent
            showModal={this.props.showModal}
            prepareForPayment={this.props.prepareForPayment}
            transaction={this.props.transaction}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <SideBarConsosComponent
            addModal
            showModal={this.props.showModal}
            changeReduc={this.props.changeReducConso}
            allProducts={this.props.products}
            categories={this.props.categories}
            transaction={transaction}
            products={productsArray || []}
            addConso={this.props.addConso}
            removeConso={this.props.removeConso}
          />
        </Grid>
      </Grid>
    )
  }
}

export default withStyles(styles)(BarComponent)



// WEBPACK FOOTER //
// ./src/routes/Bar/components/BarComponent.js